<template>
  <v-form @submit.prevent="submit"
          :disabled="form.busy">
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-subtitle v-if="slide && slide.name !== title">
        {{ slide.name }}
      </v-card-subtitle>
      <v-img :src="pages[page-1]?.url"
             height="600px"
             contain
             class="border-gray-light">
      </v-img>
      <v-card-text>
        <v-textarea v-model="form.content"
                    :label="`My notes for slide ${page}`"
                    rows="2"
                    outlined
                    :error-messages="form.errors.get('content')"
                    :disabled="form.busy"
                    clearable
                    hint="The note saves when your cursor leaves the field."
                    @click:clear="deleteNote"
                    @blur="saveNote">
        </v-textarea>
      </v-card-text>
    </v-card>
  </v-form>
</template>
<script>
import {Form} from 'vform';
import {find, isInteger, isObject, isString} from 'lodash';

export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    pages: {
      type: Array,
      required: true,
    },
    notes: {
      type: Array,
      required: true,
    },
    slides: {
      type: Array,
      required: false,
      default: [],
    }
  },
  data() {
    return {
      form: new Form({
        presentation_id: this.presentation.id,
        page: this.page,
        content: null,
      }),
      note: null,
    }
  },
  computed: {
    title() {
      return `Slide ${this.page}`
    },
    slide() {
      if (this.slides.length >= this.page) {
        return this.slides[this.page - 1];
      }
      return null;
    }
  },
  created() {
    this.initForm();
  },
  methods: {
    initForm() {
      const note = find(this.notes, n => n.page === this.page);
      if (note) {
        this.setNote(note);
      }
    },
    setNote(note) {
      this.note = note;
      if (isObject(note) && isString(note.content)) {
        this.form.content = note.content;
      } else {
        this.form.content = null;
      }
    },
    saveNote() {
      if (this.form.content) {
        this.submit();
      } else {
        this.deleteNote();
      }
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      if (isObject(this.note) && isInteger(this.note.id)) {
        if (this.note.content !== this.form.content) {
          this.form.patch(`/api/presentation-notes/${this.note.id}`)
            .then(response => {
              this.$toast.success(`Note for page ${this.page} saved successfully.`);
              this.setNote(response.data);
              this.$emit('updated')
            })
            .catch(err => {

            })
        }
      } else {
        this.form.post(`/api/presentation-notes`)
          .then(response => {
            this.$toast.success(`Note for page ${this.page} saved successfully.`);
            this.setNote(response.data);
            this.$emit('updated')
          })
          .catch(err => {

          })
      }
    },
    deleteNote() {
      if (this.form.busy) {
        return;
      }
      if (isObject(this.note) && isInteger(this.note.id)) {
        this.form.delete(`/api/presentation-notes/${this.note.id}`)
          .then(response => {
            this.setNote(null);
            this.$toast.success(`Note deleted for page ${this.page}.`);
            this.$emit('updated')
          })
          .catch(err => {

          })
      }
    }
  }
}
</script>
